export default __webpack_public_path__ + "static/media/accumulators_card.85b15e08.jpg";